<template>
  <div class="link-setting">
    <div class="top">
      <div class="flex-item">
        <b>订单确认设置</b>
        <span class="tip">设置完成后，可以自动确认订单也可以设置不同的人进行确认。</span>
      </div>
      <div class="flex-item">
        <template v-if="!isEdit">
          <el-button @click="handleEdit" type="primary">设置</el-button>
        </template>
        <template v-else>
          <el-button plain @click="handleClose">取消</el-button>
          <el-button @click="handleSave" type="primary">保存</el-button>
        </template>
      </div>
    </div>
    <div class="content">
      <template v-if="!isEdit">
        <el-descriptions :colon="false" size="medium">
          <el-descriptions-item label="订单确认人">
            <span v-if="info.orderConfirmPersonType === 3">{{ info.orderConfirmPersonUserName || '--' }}</span>
            <span v-if="info.orderConfirmPersonType === 3" class="appoint">固定员工</span>
            <span v-else>{{ info.orderConfirmPersonType === 1 ? '自动确认' : info.orderConfirmPersonType === 2 ? '根据权限配置' : '--' }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-else>
        <el-form :model="form" ref="JZForm" :rules="rules" size="mini" label-position="right" label-width="120px">
          <el-form-item label="订单确认人" prop="orderConfirmPersonType">
            <div class="position:relative;">
              <el-radio-group v-model="form.orderConfirmPersonType">
                <el-radio :label="1">
                  自动确认
                  <el-tooltip class="item" effect="dark" content="系统自动确认订单，适用于上架信息完整度高的企业" placement="right">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </el-radio>
                <el-radio :label="2">
                  不指定固定人，根据权限配置
                  <el-tooltip class="item" effect="dark" content="根据角色权限的设置，有按钮权限的用户都可以进行确认" placement="right">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </el-radio>
                <el-radio :label="3">
                  指定员工
                  <el-tooltip class="item" effect="dark" content="指定固定的员工进行订单确认" placement="bottom">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </el-radio>
              </el-radio-group>
              <el-select v-model="form.orderConfirmPersonUserId" placeholder="请选择" clearable class="employee-select">
                <el-option v-for="item in employeeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-form>
      </template>
    </div>
  </div>
</template>
<script>
import userApi from '@/api/user';
import { getTenantSellerSettingDetail, saveOrderConfirmPerson } from '@/api/shop';

export default {
  data () {
    return {
      isEdit: false,
      employeeList: [],
      info: {
        orderConfirmPersonType: '',
        orderConfirmPersonUserName: '',
      },
      form: {
        orderConfirmPersonUserId: '',
        orderConfirmPersonType: 2,
      },
      rules: {
        orderConfirmPersonType: [
          { required: true, message: '请设置订单确认人', trigger: ['blur', 'change'] },
        ],
      },
    };
  },
  methods: {
    handleEdit () {
      this.isEdit = !this.isEdit;
    },
    handleClose () {
      this.handleEdit();
    },
    handleSave () {
      this.$refs.JZForm.validate().then(async valid => {
        if (valid) {
          if (this.form.orderConfirmPersonType === 3 && !this.form.orderConfirmPersonUserId) {
            this.$message.warning('请指定员工');
            return;
          }
          await saveOrderConfirmPerson({
            orderConfirmPersonUserId: this.form.orderConfirmPersonType === 3 ? this.form.orderConfirmPersonUserId : null,
            orderConfirmPersonType: this.form.orderConfirmPersonType,
          });
          this.$message.success('保存成功');
          this.queryInfo();
          this.handleEdit();
        }
      });
    },
    async queryInfo () {
      const { body } = await getTenantSellerSettingDetail({});
      this.info.orderConfirmPersonType = body.orderConfirmPersonType;
      this.info.orderConfirmPersonUserName = body.orderConfirmPersonUserName;
      this.form.orderConfirmPersonUserId = body.orderConfirmPersonType === 3 ? body.orderConfirmPersonUserId : null;
      this.form.orderConfirmPersonType = body.orderConfirmPersonType || 2;
    },
    async queryEmployee () {
      const { body } = await userApi.getUserList({
        orderBy: [{
          orderByProperty: 'createTime',
          orderByType: 'ASC',
        }],
        pageFlag: false,
      });
      this.employeeList = (body.list || []).map(item => {
        return {
          label: item.name,
          value: item.id,
          departmentId: item.departmentId,
        };
      });
    },
  },
  async mounted () {
    await this.queryEmployee();
    await this.queryInfo();
  },
};
</script>
<style lang="scss" scoped>
.link-setting {
  font-size: 14px;
  color: #1F2733;

  .flex-item {
    display: inline-flex;
    align-items: center;
  }
  .top {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #eeeeee;

    .tip {
      font-weight: 400;
      font-size: 12px;
      color: #929AA6;
      margin: 0 15px;
    }
  }

  .content {
    padding: 20px;
    /deep/ .el-descriptions-item__label {
      color: #929AA6;
    }

    .appoint {
      background: #E2F3FE;
      border-radius: 4px;
      padding: 0 6px;
      font-weight: 400;
      font-size: 12px;
      color: #237FFA;
      margin-left: 15px;
      margin-top: 2px;
    }

    /deep/ .el-radio {
      width: 100%;
      padding: 10px 0;
    }

    .employee-select {
      width: 240px;
      position: absolute;
      bottom: 5px;
      left: 110px;
    }
  }
}
</style>
